import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-customer-footer',
  templateUrl: './customer-footer.component.html',
  styleUrls: ['./customer-footer.component.scss'],
})
export class CustomerFooterComponent {
  public readonly currentYear = new Date().getFullYear();
}
